import CustomAvatar from 'components/global/CustomAvatar'
import CustomModal from 'components/global/CustomModal'
import React, { useEffect, useState } from 'react'
import { leagueGamesStore } from 'state/league/leageGames'
import { useGetLeagueGames } from 'api/league/leagueGames/leagueGames'
import { leagueEventStore } from 'state/league/leagueEvent'
import Spinner from 'components/Spinner'
import { convertMinutesToLocalTime } from 'helper/utility'
import moment from 'moment'
import { LeagueGameRespType, LeagueGamesByRoundDate } from 'types/league/leagueGame'
import '../styles/mainmodals/selectGame.scss'

const SelectGameForLog: React.FC = () => {
  const { leagueData } = leagueEventStore(store => ({ leagueData: store.leagueData }))
  const {
    selectGameForLogModal,
    setSelectGameForLogModal,
    setEnterLogModal,
    setSelectedGame,
  } = leagueGamesStore(store => ({
    selectGameForLogModal: store.selectGameForLogModal,
    setSelectGameForLogModal: store.setSelectGameForLogModal,
    setEnterLogModal: store.setEnterLogModal,
    setSelectedGame: store.setSelectedGame,
  }))
  const [params] = useState({ leagueId: leagueData?._id || '' })

  const {
    data: gamesByLeagueId,
    isLoading: gamesLoading,
    isFetching: gamesFetching,
    refetch: refetchGames,
  } = useGetLeagueGames(params)

  useEffect(() => {
    refetchGames()
  }, [params])

  const closeModal = () => setSelectGameForLogModal(false)

  const handleSelect = (game: LeagueGameRespType) => {
    setSelectedGame(game)
    setSelectGameForLogModal(false)
    setEnterLogModal(true)
  }

  return (
    <CustomModal
      openModal={selectGameForLogModal}
      isCloseModalCustom
      closeModal={closeModal}
      title="Select game"
      footer={false}
    >
      <>
        {gamesLoading || gamesFetching ? (
          <div><Spinner /></div>
        ) : (
          <>
            {gamesByLeagueId?.length ? (
              <>
                {gamesByLeagueId.map((gameRounds: LeagueGamesByRoundDate) => (
                  <div className="round-box mt-10 pr-10px" key={gameRounds.round}>
                    <h3 className="text-14 w-600">Round {gameRounds.round}</h3>
                    {gameRounds.dates.map(gameDates => (
                      <React.Fragment key={gameDates.date}>
                        <div className="date-container">
                          <h4>{moment(gameDates.date).format('dddd, MMMM DD')}</h4>
                        </div>
                        {gameDates.games.map(game => (
                          <div className="game-box" key={game._id}>
                            <div className="team-time-container">
                              <div className="team">
                                <CustomAvatar
                                  size={40}
                                  src={game.homeTeam.team.profilePhoto?.thumb}
                                  name={game.homeTeam.team.name}
                                />
                                <b>{game.homeTeam.team.name}</b>
                              </div>
                              <div className="time">
                                <span>{game.courtFieldNumber}</span>
                                <b>{convertMinutesToLocalTime(game.timings.startTime)}</b>
                              </div>
                              <div className="team">
                                <CustomAvatar
                                  size={40}
                                  src={game.awayTeam.team.profilePhoto?.thumb}
                                  name={game.awayTeam.team.name}
                                />
                                <b>{game.awayTeam.team.name}</b>
                              </div>
                            </div>
                            <button className="select-btn" onClick={() => handleSelect(game)}>
                              Select
                            </button>
                          </div>
                        ))}
                      </React.Fragment>
                    ))}
                  </div>
                ))}
              </>
            ) : (
              <div>No games created</div>
            )}
          </>
        )}
      </>
    </CustomModal>
  )
}

export default SelectGameForLog
